export default __webpack_public_path__ + "static/cms-blog-bd536da68838d1df3e11b87f2139dbe2.png";